import React from "react";
import {useTheme} from "@emotion/react";

import {Checkbox} from "@pg-design/checkbox-module";
import {zIndex} from "@pg-design/helpers-css";

import {ISearchFilterOption} from "../../types/ISearchFilters";

interface IProps {
    filterId: string;
    filterOption: ISearchFilterOption<string | number>;
    isChecked: boolean;
    onChange: (name: string, checked: boolean, value: string) => void;
    className?: string;
}

export const FilterCheckbox = (props: IProps) => {
    const theme = useTheme();

    return (
        <Checkbox
            id={`${props.filterId}_${props.filterOption.id}`}
            name={`${props.filterId}_${props.filterOption.id}`}
            labelContent={props.filterOption.label}
            checked={props.isChecked}
            value={props.filterOption.value}
            onChange={props.onChange}
            checkedMarkColor={theme.globals.checkbox.checkedColor}
            css={zIndex(1)} // overriding default zIndex
            className={props.className}
            disabled={props.filterOption.isDisabled}
        />
    );
};
import React from "react";
import {useTheme} from "@emotion/react";

import {Checkbox} from "@pg-design/checkbox-module";
import {zIndex} from "@pg-design/helpers-css";

import {ISearchFilterOption} from "../../types/ISearchFilters";

interface IProps {
    filterId: string;
    filterOption: ISearchFilterOption<string | number>;
    isChecked: boolean;
    onChange: (name: string, checked: boolean, value: string) => void;
    className?: string;
}

export const FilterCheckbox = (props: IProps) => {
    const theme = useTheme();

    return (
        <Checkbox
            id={`${props.filterId}_${props.filterOption.id}`}
            name={`${props.filterId}_${props.filterOption.id}`}
            labelContent={props.filterOption.label}
            checked={props.isChecked}
            value={props.filterOption.value}
            onChange={props.onChange}
            checkedMarkColor={theme.globals.checkbox.checkedColor}
            css={zIndex(1)} // overriding default zIndex
            className={props.className}
            disabled={props.filterOption.isDisabled}
        />
    );
};
